function toCapitalised(str) {
  return str?.replace(/\b\w+/g, function (s) {
    return s?.charAt(0).toUpperCase() + s.substr(1).toLowerCase()
  })
}
export default toCapitalised
